// extracted by mini-css-extract-plugin
export default {"container":"lh_m82","pseudoLink":"V5EeF7"};